export const BENZIN = 1039;
export const DIESEL = 1040;
export const ELEKTRO = 1044;
export const ERDGAS = 1042;
export const ETHANOL = 1045;
export const GAS = 1041;
export const HYBRID = 1046;
export const WASSERSTOFF = 1047;
export const OTHER = 1043;
